module.exports = __webpack_public_path__ + "fonts/okticon.5e1f49dda77e01218444c76678856d3d.ttf?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/okticon.ttf
// module id = 742
// module chunks = 9